import * as React from 'react';

import { ClientLogger } from 'bernie-client';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { PropertyListingBadgeModel } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';

interface RenderBadgeProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  travelAd: {
    impressionTrackingUrl: string;
  };
  displaySecondaryBadge: boolean;
  hideSponsored?: boolean;
}

const travelAdImpressions = [];
export const TitleBadge: React.FunctionComponent<RenderBadgeProps> = ({
  propertyListingBadgeModel,
  travelAd,
  displaySecondaryBadge,
  hideSponsored
}) => {
  const { primary, secondary } = { ...propertyListingBadgeModel };
  const { impressionTrackingUrl } = { ...travelAd };
  if (impressionTrackingUrl && !travelAdImpressions.includes(impressionTrackingUrl)) {
    travelAdImpressions.push(impressionTrackingUrl);
    fetch(impressionTrackingUrl).catch(() => {
      const logger = ClientLogger.getLoggerWithIdentifier('pwa.component.title-badge');
      logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'TRAVELAD_IMPRESSION_FAILURE'), ' URL=[' + impressionTrackingUrl + ']');
    });
  }
  const shouldSuppressIfSponsored = badge => {
    if (!badge || !badge.theme) {
      return null;
    }

    return hideSponsored && String(badge.theme) === 'SPONSORED';
  };

  return (
    <React.Fragment>
      {primary && (primary.text || primary.icon) && !shouldSuppressIfSponsored(primary) && (
        <UitkBadge
          className="title__badge all-t-margin-two"
          icon={primary.icon}
          text={primary.text}
          theme={UitkBadgeTheme[primary.theme]}
          data-stid="primary-badge"
        />
      )}
      {displaySecondaryBadge && secondary && (secondary.text || secondary.icon) && !shouldSuppressIfSponsored(secondary) && (
        <UitkBadge
          className="title__badge title__badge-details"
          text={secondary.text}
          theme={UitkBadgeTheme[secondary.theme]}
          data-stid="secondary-badge"
        />
      )}
    </React.Fragment>
  );
};

TitleBadge.displayName = 'TitleBadge';
